import(/* webpackMode: "eager" */ "/opt/build/repo/app/global-error.tsx");
